<template>
  <div class="templateNavigation">
    <div class="navigation">
      <div class="branding">
        <img src="@/assets/images/branding/CanonVision.png" alt="Canon Vision">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Navigation',
}
</script>

<style scoped lang="scss">
.navigation{
  height: 300px;
  background-color: #000;
  padding: 50px 60px;

  .branding{
    height: 200px;
    width: 100%;
    overflow: hidden;

    img{
      height: 200px;
    }
  }
}
@media (max-width: 768px){
  .navigation{
    padding: 50px 15px;

    .branding{
      text-align: center;
    }
  }
}
</style>
